export default function SectionHeader({ eyebrow, title, text, align = 'center' }) {
  return (
    <div className={`section-header align-${align}`}>
      {eyebrow ? <span>{eyebrow}</span> : null}
      <h1>{title}</h1>
      {text ? <p>{text}</p> : null}
    </div>
  );
}
